/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var FavoriteOffIcon = createIcon("FavoriteOffIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#6D7478';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "17",
    height: "16",
    viewBox: "0 0 17 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "m5.012 5.24.274-.026.123-.246L7.514.796a.546.546 0 01.424-.293L8.008.5a.55.55 0 01.478.299l2.105 4.172.124.245.273.027 4.013.398h.008c.19.017.355.131.437.3l.026.06a.537.537 0 01-.13.557l-3.326 3.295-.207.206.077.282 1.233 4.48a.542.542 0 01-.136.515l-.054.049a.54.54 0 01-.575.058l-.002-.001-4.131-2.046-.222-.11-.222.11-4.122 2.042-.003.001a.542.542 0 01-.534-.026l-.059-.044a.544.544 0 01-.173-.556l1.231-4.475.078-.282-.208-.205L.659 6.555a.537.537 0 01-.144-.505l.02-.069a.534.534 0 01.45-.341h.007l4.02-.4Z",
    stroke: _color
  }));
}, {
  "replaceColor": true
});